export const defaultLanguage = {
  DefaultLocaleID: 1,
  lang: 'English',
  locale: 'en-US',
}
